document.addEventListener('DOMContentLoaded', function() {
    // Get DOM elements
    const navBurger = document.getElementById('nav-burger');
    const navMenu = document.getElementById('gh-nav-menu');
    const navOverlay = document.getElementById('gh-nav-overlay');
    const body = document.body;

    // Setup user account menu toggle
    const accountButton = document.getElementById('account-menu-button');
    const accountMenu = document.getElementById('account-menu');

    if (accountButton && accountMenu) {
        accountButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const authDropdown = document.querySelector('.gh-auth-dropdown');
            if (authDropdown) {
                // Close any other open dropdowns first
                document.querySelectorAll('.is-open').forEach(openDropdown => {
                    if (openDropdown !== authDropdown) {
                        openDropdown.classList.remove('is-open');
                    }
                });

                // Toggle this dropdown
                authDropdown.classList.toggle('is-open');
            }
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', function(e) {
            const authDropdown = document.querySelector('.gh-auth-dropdown');
            if (authDropdown && authDropdown.classList.contains('is-open') && !authDropdown.contains(e.target)) {
                authDropdown.classList.remove('is-open');
            }
        });

        // Close dropdown when pressing escape key
        document.addEventListener('keydown', function(e) {
            const authDropdown = document.querySelector('.gh-auth-dropdown');
            if (e.key === 'Escape' && authDropdown && authDropdown.classList.contains('is-open')) {
                authDropdown.classList.remove('is-open');
            }
        });
    }

    // Toggle navigation menu
    function toggleNavMenu() {
        navMenu.classList.toggle('is-open');
        navOverlay.classList.toggle('is-active');
        body.classList.toggle('overflow-hidden');
    }

    // Close navigation menu
    function closeNavMenu() {
        navMenu.classList.remove('is-open');
        navOverlay.classList.remove('is-active');
        body.classList.remove('overflow-hidden');
    }

    // Event listeners
    if (navBurger && navMenu && navOverlay) {
        // Toggle menu on burger click
        navBurger.addEventListener('click', function(e) {
            e.preventDefault();
            toggleNavMenu();
        });

        // Close menu on overlay click
        navOverlay.addEventListener('click', closeNavMenu);

        // Close menu on escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                closeNavMenu();
            }
        });

        // Close menu on window resize (if in desktop mode)
        window.addEventListener('resize', function() {
            if (window.innerWidth >= 1024) {
                closeNavMenu();
            }
        });
    }
});

// Add some CSS to body when menu is open
document.head.insertAdjacentHTML('beforeend', `
    <style>
        body.menu-open {
            overflow: hidden;
        }

        @media (min-width: 768px) {
            body.menu-open {
                overflow: auto;
            }
        }
    </style>
`);